import { useEffect, useState } from "react";
import Constantes from "../../constantes";


async function obtenerInventario() {
    try {
        const respuesta = await fetch(Constantes.RUTA_API + '/inventario/getInventario', {
            method: 'GET',
            credentials: 'include'
        });
        const data = await respuesta.json();

        if (!data.error) {
            return data.message;
        } else {
            console.error("Error al obtener el inventario:", data.message);
            return [];
        }
    } catch (err) {
        console.error("Error de FRONT al obtener el inventario:", err);
        return [];
    }
}




function Inventario() {

    const [cargado, setCargado] = useState(false);
    const [inventario, setInventario] = useState([]);
    const [imagenesInsignias, setImagenesInsignias] = useState([]);

    useEffect(() => {
        obtenerInventario().then((data) => setInventario(data));
    }, []);

    useEffect(() => {
        for (let i = 0; i < inventario.insignias?.length; i++) {
            const data= inventario.images_insignias[i];
                setImagenesInsignias((prevState) => [...prevState, data]);
        }

        console.log(inventario);
    }, [inventario]);

    useEffect(() => {
        setCargado(true);

    }, [imagenesInsignias]);



    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white" style={{ flexDirection: "column", overflow: "hidden" }}>
                <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", boxSizing: "border-box", padding: "10px" }}>
                    <h2 style={{ margin: 0, marginBottom: "10px", textAlign: "center" }}>Inventario de Insignias</h2>
                    {!cargado && <p style={{ textAlign: "center" }}>Cargando insignias...</p>}
                    {cargado &&
                        <div className="row justify-content-center" style={{ overflowY: "auto", flex: 1, boxSizing: "border-box", width: "100%" }}>
                            {inventario.insignias && inventario.insignias.map((insignia, index) => (
                                <div className="card col-2 bg-dark" key={insignia.nombre_monumento} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', boxSizing: "border-box" , height:"250px", width:"250px", overflowY:"auto" }}>
                                    <img src={imagenesInsignias[index]} style={{height:"100px", width:"100px" }} class="card-img-top" alt={`Insignia ${insignia.nombre_monumento}`} />
                                    <div className="card-body d-flex bg-dark flex-column align-items-center text-white text-center" >
                                        <p className="mx-2 col-12">
                                            <br />
                                            {insignia.nombre_monumento}
                                            <br />
                                            id:{insignia.id_monumento}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                </div>
            </div>
            <title>Inventario</title>
        </>
    );
}



export default Inventario;